import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

// Kuimport picha za makala (Static Assets zilizopo)
import s1 from '../assets/image27.jpeg';
import s2 from '../assets/image28.jpeg';
import s3 from '../assets/image29.jpeg';
import s4 from '../assets/image30.jpeg';
import s5 from '../assets/banner1.png';

// Kuitwa kwa vipengele mbalimbali vya kurasa
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneNews from "./OneNews"; // Kadi uliyorekebisha hapo awali (inayopokea data.coverPhoto na data.title)

import { FaNewspaper } from "react-icons/fa";

export default function NewsBanner(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [newsList, setNewsList] = useState([]);

  // DATA YA HABARI 4 ZA KISASA - UTALAAK NA MAFANIKIO YA YCSC SACCOS
  const staticNewsData = [
    {
      uuid: "news-001",
      title: "Mkutano Mkuu wa Mwaka (AGM) Kufanyika Mwezi Huu Kujadili Gawio la Hisa",
      coverPhoto: s1, // Tuta-inject picha za ndani kupitia logic chini kwa usalama
      description: "Wanachama wote wa YCSC SACCOS mnasasishwa kuhudhuria mkutano mkuu wa mwaka utakaofanyika kujadili ukuaji, kupitisha bajeti na kuigawa faida ya mwaka.",
      created_at: "2026-06-15T10:00:00Z"
    },
    {
      uuid: "news-002",
      title: "YCSC SACCOS Sasa Yazindua Mfumo Mpya wa Kidijitali wa Maombi ya Mikopo",
      coverPhoto: s2,
      description: "Katika kurahisisha huduma zetu, sasa unaweza kuomba mkopo wa dharura au maendeleo moja kwa moja kupitia mfumo wetu mpya bila karatasi.",
      created_at: "2026-05-28T08:30:00Z"
    },
    // {
    //   uuid: "news-003",
    //   title: "Mafunzo Maalum ya Usimamizi wa Fedha na Uwekezaji kwa Wanachama Wapya",
    //   coverPhoto: s3,
    //   description: "Kamati ya elimu imeandaa semina ya siku moja kwa ajili ya kuwajengea uwezo wanachama juu ya namna bora ya kukuza biashara na kusimamia mikopo.",
    //   created_at: "2026-05-10T14:15:00Z"
    // },
    {
      uuid: "news-004",
      title: "Ukuaji wa Mtaji wa Chama: Akiba na Amana Zafikia Kiwango cha Juu Zaidi",
      coverPhoto: s4,
      description: "Ripoti ya robo mwaka inaonyesha ongezeko kubwa la ukwasi na amana za wanachama, jambo linalothibitisha uaminifu mkubwa ndani ya ushirika wetu.",
      created_at: "2026-04-18T11:00:00Z"
    },
    {
      uuid: "news-005",
      title: "Kurudisha kwa Jamii Wenye Uhitaji Kupitia YCSC Community Day",
      coverPhoto: s5,
      description: "Katika chama chetu, tunatambua umuhimu wa kugusa maisha ya wengine. Kila mwaka ifikapo mwezi wa pili, tunakuwa na siku rasmi ya kuwasaidia na kuwashika mkono wale wenye uhitaji katika jamii yetu.",
      created_at: "2026-04-18T11:00:00Z"
    }
  ];

  async function init() {
    setReady(false);

    /* ==================================================================
    DYNAMIC PARTS (COMMENTED OUT FOR FUTURE API INTEGRATION)
    ==================================================================
    try {
      await Promise.all([
        appContext.getAllNews(),
      ]);
      if (appContext.allNews && appContext.allNews.length > 0) {
        setNewsList(appContext.allNews);
      }
    } catch (error) {
      console.error("Error fetching dynamic news:", error);
    }
    ==================================================================
    */

    // INJECTING LOCAL STATIC ASSETS INTO THE LOGIC TO MATCH CDN_URL LOGIC
    // Kwa kuwa kadi yako ya OneNews inatumia `CDN_URL + data.coverPhoto`, tunaondoa hitaji hilo kwa kuweka picha zetu hapa moja kwa moja.
    const mappedStaticNews = staticNewsData.map((news, index) => {
      const images = [s1, s2, s3, s4];
      return {
        ...news,
        // Ili kuzuia migogoro na CDN_URL, tunaweka picha moja kwa moja kama fake link au override
        coverPhoto: images[index] ? "" : "", 
        // TIP: Kama kadi ya OneNews inasoma `CDN_URL + data.coverPhoto`, hakikisha unabadilisha kadi kule ikubali picha za moja kwa moja au tumia hack hii hapa chini:
      };
    });

    // Ili kadi yako ya `OneNews` isipate shida na `CDN_URL`, tutahakikisha data.coverPhoto inabeba image variable yenyewe na kule kwenye OneNews unaweza kuondoa CDN_URL au kuipita
    mappedStaticNews[0].coverPhoto = ""; // Ili OneNews yako ya sasa isifeli, tutapitisha picha hizi
    
    // Kwa urahisi, tutapachika picha moja kwa moja kwenye data yetu:
    const finalNews = [
      { ...staticNewsData[0], coverPhoto: "../../src/assets/med/s1.jpg" }, // Njia mbadala au unaweza kubadilisha OneNews isome variable
      { ...staticNewsData[1], coverPhoto: "../../src/assets/med/s2.jpg" },
      { ...staticNewsData[2], coverPhoto: "../../src/assets/med/s3.jpg" },
      { ...staticNewsData[3], coverPhoto: "../../src/assets/med/s4.jpg" }
    ];
    
    // NOTE: Ili OneNews isivunjike kwa sababu ya `CDN_URL`, unaweza kutumia picha za mtandaoni kwa sasa hapa chini ili zionekane vizuri popote:
    const onlinePremiumImages = [
      "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?q=80&w=600&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1563013544-824ae1d704d3?q=80&w=600&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1542744173-8e0ee26d222f?q=80&w=600&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=600&auto=format&fit=crop"
    ];

    const finalizedStaticNews = staticNewsData.map((item, idx) => ({
      ...item,
      // Hila hii inafuta athari ya CDN_URL kwa kuweka link kamili ya mtandao ambayo itapuuza CDN_URL kama ni tupu au unaondoa CDN_URL kwenye kadi
      coverPhoto: onlinePremiumImages[idx]
    }));

    setNewsList(finalizedStaticNews);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <div className="ycsc-news-landing-section animate__animated animate__fadeIn">
        

        {/* 2. NEWS GRID SECTION */}
        <section className="py-5 bg-light-surface">
          <div className="container">
            
            <div className="row mb-4 align-items-center">
              <div className="col-md-8">
                <div className="d-flex align-items-center gap-2 text-primary">
                  <FaNewspaper className="text-warning fs-4" />
                  <span className="premium-accent-kicker m-0">Makala na Taarifa</span>
                </div>
                <h2 className="premium-section-title mt-1">Zilizopo Hivi Punde</h2>
              </div>
            </div>

            {/* GRID LAYER */}
            <div className="row g-4">
              {staticNewsData.length > 0 ? (
                staticNewsData.map((item, i) => (
                  <div key={item.uuid || i} className="col-12 col-md-6">
                    {/* Kadi yako maridadi ya OneNews tuliyoiboresha */}
                    <OneNews data={item} />
                  </div>
                ))
              ) : (
                <div className="col-md-12 text-center py-5">
                  <h6 className="text-muted">Hakuna taarifa yoyote iliyopatikana kwa sasa.</h6>
                </div>
              )}
            </div>

          </div>
        </section>

        {/* 3. HORIZONTAL IMAGE STRIP FOR LOWER SECTION ACCENT */}
        <section className="bg-white border-top">
          <HorizontalImageStrip images={[s1, s2, s3, s4]} />
        </section>

      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }
}